module.exports = __webpack_public_path__ + "static/media/box.1779582a.svg";